import React, { useEffect, useState, useRef } from "react";
import { Card, Spin, Carousel, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../api/axiosInstance";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

const { Paragraph, Title } = Typography;

const ExplorePlaces = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const carouselRef = useRef(null);

  const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await axiosInstance.get(
          `/products?populate[thumbnail][fields]=url&populate[sub_products][populate][sub_product_image][fields]=url`
        );

        const allProducts = res.data.data || [];

        const formattedProducts = allProducts.map((product) => ({
          id: product.id,
          name: product.name,
          slug: product.slug,
          description: product.description,
          imageUrl: product.thumbnail?.url
            ? `${API_URL}${product.thumbnail.url}`
            : null,
        }));

        setProducts(formattedProducts);
      } catch (err) {
        console.error("API Error:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center items-center py-10">
        <Spin size="large" tip="Loading products..." />
      </div>
    );
  }

  const SampleNextArrow = ({ onClick }) => (
  <div
    className="absolute right-0 top-1/2 -translate-y-1/2 z-10 cursor-pointer bg-white shadow-md w-10 h-10 rounded-full flex items-center justify-center"
    onClick={onClick}
  >
    ▶
  </div>
);

const SamplePrevArrow = ({ onClick }) => (
  <div
    className="absolute left-0 top-1/2 -translate-y-1/2 z-10 cursor-pointer bg-white shadow-md w-10 h-10 rounded-full flex items-center justify-center"
    onClick={onClick}
  >
    ◀
  </div>
);

  return (
 <div className="relative"> {/* padding prevents overlap */}

  {/* LEFT ARROW */}
  <button
    onClick={() => carouselRef.current.prev()}
    className="absolute -left-5 top-1/2 -translate-y-1/2 z-10 w-10 h-10 bg-white shadow rounded-full flex items-center justify-center"
  >
    <LeftOutlined />
  </button>

  {/* RIGHT ARROW */}
  <button
    onClick={() => carouselRef.current.next()}
    className="absolute -right-5 top-1/2 -translate-y-1/2 z-10 w-10 h-10 bg-white shadow-lg rounded-full flex items-center justify-center hover:scale-110 transition"
  >
    <RightOutlined />
  </button>

  {/* CAROUSEL */}
  <Carousel
    ref={carouselRef}
    dots={false}
    infinite={false}
    slidesToShow={5}
    slidesToScroll={1}
    responsive={[
      {
        breakpoint: 1024,
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 1 },
      },
    ]}
  >
    {products.map((product) => (
      <div key={product.id} className="px-[5px]">
        <Card
          hoverable
          className="relative rounded-2xl overflow-hidden shadow-md group border-0 [&_.ant-card-body]:p-0 h-full"
          onClick={() => navigate(`/activity/${product.slug}`)}
          cover={
            <div className="relative">
              {product.imageUrl ? (
                <img
                  alt={product.name}
                  src={product.imageUrl}
                  className="w-full object-cover h-[350px]"
                />
              ) : (
                <div className="w-full h-[350px] bg-gray-200 flex items-center justify-center text-gray-500">
                  No Image
                </div>
              )}

              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-b from-[rgba(0,0,0,0)_61%] to-primary opacity-80 group-hover:opacity-90 transition-all" />

              {/* Title */}
              <div className="absolute bottom-3 left-3 text-white font-medium text-lg">
                {product.name}
              </div>
            </div>
          }
        />
      </div>
    ))}
  </Carousel>
</div>
  );
};

export default ExplorePlaces;